export default __webpack_public_path__ + "static/media/3020_folded.d9118e2f.jpg";